import AppsPage from 'components/Apps'

export default AppsPage
